var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-drawer-menu" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.drawer.show
          ? _c("div", { staticClass: "modal" }, [
              _c("div", {
                staticClass: "modal-background",
                on: {
                  click: function($event) {
                    return _vm.DRAWER()
                  }
                }
              })
            ])
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slideRight" } }, [
        _vm.drawer.show
          ? _c("div", { staticClass: "quickview" }, [
              _c("header", { staticClass: "quickview-header" }, [
                _c("div", { staticClass: "title" }, [_vm._v("MENU")]),
                _c("span", {
                  staticClass: "delete",
                  on: {
                    click: function($event) {
                      return _vm.DRAWER()
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "quickview-body" }, [
                _c(
                  "div",
                  { staticClass: "quickview-block" },
                  [
                    _vm._l(_vm.pages, function(i) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "panel-block",
                            attrs: { href: _vm.pageLink(i) }
                          },
                          [
                            _c("span", { staticClass: "panel-icon" }, [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons has-text-primary"
                                },
                                [_vm._v("chevron_right")]
                              )
                            ]),
                            _c("span", [_vm._v(_vm._s(i.name))])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }